const t = (e = 0) => !0;
export {
  t as default
};
